import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CDMD_CEREAL_PESO_TOTAL } from '../../../../../config/tables'

function TablaCircuitoCerealPesoTotalView () {
  return (
    <div style={{ margin: '8px auto' }}>
      <MuiTable id={TABLA_CDMD_CEREAL_PESO_TOTAL} />
    </div>
  )
}

export default TablaCircuitoCerealPesoTotalView
